<template>
  <div class="wrap">
    <div class="main">
      <div class="accountWrap">
        <h2>用户登录</h2>
        <el-input v-model="username" class="mt20" placeholder="请输入用户名"></el-input>
        <el-input v-model="password" type="password" @keyup.enter.native="login()" class="mt20" placeholder="请输入密码"></el-input>
        <el-button class="mt20 w100" @click="login()" type="primary">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  mounted () {
    console.log(this)
  },
  methods: {
    login () {
      this.$postForm('/user/login', { username: this.username, password: this.password }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          localStorage.setItem('Authorization', res.data.data.access_token)
          this.$router.push('/')
        } else {
          this.$notify.error({
            title: '失败',
            message: res.data.msg
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
